import React from 'react';
import constants from '../constants';

export const redirectToLoginUrl = (url = window.location.href) => {
  const encodedUrl = encodeURIComponent(url);
  return `${constants.questUrl}/admin/auth/login?redirect=${encodedUrl}`;
};

export const redirectToLogin = (url) => {
  window.top.location = redirectToLoginUrl(url);
};

export const checkisUnauthorized = (error) => {
  if (error?.status === 401 || error?.status === 403) {
    if (!this.session) {
      redirectToLogin();
    } else {
      console.log('404 not found');
    }
  }
};

export default React.createContext({
  session: null,
  checkisUnauthorized: null,
  redirectToLogin: null,
  redirectToLoginUrl: null
});
